module.exports = __webpack_public_path__ + "img/not-found.7ec8755.png";